import { useSelector } from 'react-redux'

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
const PARTS = ['morning', 'afternoon', 'evening']

interface RequestsMomentsProps {
    momentIds?: number[]
}

interface RequestMoment {
    question_id: number
    day_of_the_week: number
    part_of_the_day: number
}

interface RequestsEntities {
    requestsMoments?: Record<number, RequestMoment>
    questions?: Record<number, { question_name_filter: string }>
}

interface RequestsState {
    requests: {
        entities: RequestsEntities
    }
}

const RequestsMoments = ({ momentIds = [] }: RequestsMomentsProps) => {
    const { requestsMoments = {}, questions = {} } = useSelector(
        (state: RequestsState) => state.requests.entities,
    )
    const questionsIds = [
        ...new Set(momentIds.map((momentId) => requestsMoments[momentId]?.question_id)),
    ]
    const getReadableName = (dayNr: number, partNr: number) =>
        `${DAYS[dayNr - 1]} ${PARTS[partNr - 1]}`

    return (
        <>
            {questionsIds.map((questionId) => {
                const compareMoments = (a: RequestMoment, b: RequestMoment): number => {
                    if (a.day_of_the_week !== b.day_of_the_week) {
                        return a.day_of_the_week > b.day_of_the_week ? 1 : -1
                    }
                    if (a.part_of_the_day !== b.part_of_the_day) {
                        return a.part_of_the_day > b.part_of_the_day ? 1 : -1
                    }
                    return 0
                }

                const moments = momentIds
                    .map((momentId) => requestsMoments[momentId])
                    .filter((moment): moment is RequestMoment => moment !== undefined)
                    .filter((moment) => moment.question_id === questionId)
                    .sort(compareMoments)
                    .map((moment) =>
                        getReadableName(moment.day_of_the_week, moment.part_of_the_day),
                    )
                    .join(', ')

                if (!moments) return null

                return (
                    <tr
                        key={`requests_moments_${questionId}`}
                        className="hover:bg-grey-200 transition-colors">
                        <td className="py-1.5 pr-4 text-md text-neutral-600 font-medium align-top w-[180px]">
                            {questions[questionId]?.question_name_filter}
                        </td>
                        <td className="py-1.5 text-md text-neutral-900 align-top">{moments}</td>
                    </tr>
                )
            })}
        </>
    )
}

export default RequestsMoments
